(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7594],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 22495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51649);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65885);
/* harmony import */ var _api_wave_users__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71231);
/* harmony import */ var _store_authModalShow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24001);
/* harmony import */ var _store_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73471);
/* harmony import */ var _ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31066);
/* harmony import */ var _ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);














function ListButton(_ref) {
  var _cn;

  var product = _ref.product,
      _ref$isProductDetails = _ref.isProductDetails,
      isProductDetails = _ref$isProductDetails === void 0 ? false : _ref$isProductDetails,
      _ref$isFloating = _ref.isFloating,
      isFloating = _ref$isFloating === void 0 ? true : _ref$isFloating;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isFavorite = _useState[0],
      setIsFavorite = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isSuggested = _useState2[0],
      setIsSuggested = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      animate = _useState3[0],
      setAnimate = _useState3[1];

  var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z();
  var token = cookies.get('token');
  var tooltipFavorite = 'Κάνε κλικ στο εικονίδιο της καρδιάς για να προσθέσεις το προϊόν στα αγαπημένα σου!';
  var tooltipSuggested = 'Η έξυπνη πρόταση μας, καθώς ψωνίζεις συχνά το συγκεκριμένο προϊόν! Κάνε κλικ στο εικονίδιο της καρδιάς εάν θέλεις να το προσθέσεις στα αγαπημένα σου!';
  var tooltipUnfavorite = 'Εάν θέλεις να αφαιρέσεις το συγκεκριμένο προϊόν από τα αγαπημένα σου, κάνε κλικ στο εικονίδιο της καρδιάς';

  function onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    var user = _store_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getValue */ .Z.getValue();

    if (!(user !== null && user !== void 0 && user._id)) {
      _store_authModalShow__WEBPACK_IMPORTED_MODULE_4__/* .AuthFavoriteModal.update */ .u.update(true);
      return;
    }

    var action = isFavorite ? 'remove' : 'add';
    if (action === 'add') setAnimate(true);
    setIsFavorite(!isFavorite);
    updateFavorites(user, action);
  }

  function updateFavorites(_x, _x2) {
    return _updateFavorites.apply(this, arguments);
  }

  function _updateFavorites() {
    _updateFavorites = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user, action) {
      var sku, authToken, _yield$updateUserList, favoritesUpdated, error, _user$lists, lists, existingLists, updatedLists;

      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sku = product.sku;
              authToken = user.authToken;
              _context.next = 4;
              return (0,_api_wave_users__WEBPACK_IMPORTED_MODULE_3__/* .updateUserLists */ .zt)(user._id, {
                action: action,
                products: [sku]
              }, authToken || token);

            case 4:
              _yield$updateUserList = _context.sent;
              favoritesUpdated = _yield$updateUserList.list;
              error = _yield$updateUserList.error;

              if (!error) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              _user$lists = user.lists, lists = _user$lists === void 0 ? [] : _user$lists;
              existingLists = lists.filter(function (l) {
                return l.type !== 'favorites';
              });
              updatedLists = [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(existingLists), [favoritesUpdated]);
              _store_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].setLists */ .Z.setLists(updatedLists);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _updateFavorites.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var lists$ = _store_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getLists */ .Z.getLists().subscribe(function (lists) {
      var _lists$find, _lists$find2;

      var favorites = ((_lists$find = lists.find(function (v) {
        return v.type === 'favorites';
      })) === null || _lists$find === void 0 ? void 0 : _lists$find.products) || [];

      var _isFavorite = favorites.some(function (f) {
        return f.sku === product.sku;
      });

      setIsFavorite(_isFavorite);
      if (_isFavorite) return;
      var suggested = ((_lists$find2 = lists.find(function (v) {
        return v.type === 'suggested';
      })) === null || _lists$find2 === void 0 ? void 0 : _lists$find2.products) || [];

      var _isSuggested = suggested.some(function (f) {
        return f.sku === product.sku;
      });

      setIsSuggested(_isSuggested);
    });
    return function () {
      lists$.unsubscribe();
    };
  }, []);
  return !isProductDetails ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn), (_cn = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_cn, (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().animation), animate), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_cn, (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().floating), isFloating), _cn)),
    onClick: onClick,
    onAnimationEnd: function onAnimationEnd() {
      return setAnimate(false);
    },
    "data-cy": "fav",
    children: isFavorite ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdHeart */ .$g3, {
      className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
      title: tooltipUnfavorite
    }) : isSuggested ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().iconSuggested),
      title: tooltipSuggested
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdHeartEmpty */ .AWH, {
      className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
      title: tooltipFavorite
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().favoriteContainer),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().favoriteBtn), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().animation), animate)),
      onClick: onClick,
      onAnimationEnd: function onAnimationEnd() {
        return setAnimate(false);
      },
      children: isFavorite ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdHeart */ .$g3, {
        className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
        title: tooltipUnfavorite
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdHeartEmpty */ .AWH, {
        className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
        title: tooltipFavorite
      })
    }), isFavorite ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
      className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().favoritesText),
      children: "\u0391\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03BF"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
      className: (_ListButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().favoritesText),
      children: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1"
    })]
  });
}

/***/ }),

/***/ 51116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NextArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80075);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function NextArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), _classNames)),
    onClick: onClick,
    "aria-label": "next",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowRight */ .Bqb, {
      className: (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow forward - Arrow right"
    })
  });
}

/***/ }),

/***/ 55416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrevArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19392);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function PrevArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), _classNames)),
    onClick: onClick,
    "aria-label": "previous",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowLeft */ .RL9, {
      className: (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow back - Arrow left"
    })
  });
}

/***/ }),

/***/ 33401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_Products; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/api/Products.js
var Products = __webpack_require__(16562);
// EXTERNAL MODULE: ./src/components/CategoriesAside/CategoriesAside.jsx + 2 modules
var CategoriesAside = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/CategoriesBanner/CategoriesBanner.jsx + 1 modules
var CategoriesBanner = __webpack_require__(11848);
// EXTERNAL MODULE: ./src/components/CategoriesSelect/CategoriesSelect.jsx
var CategoriesSelect = __webpack_require__(16723);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./src/components/DeliveryBanner/DeliveryBanner.jsx + 3 modules
var DeliveryBanner = __webpack_require__(54196);
// EXTERNAL MODULE: ./src/components/FavoritesAside/FavoritesAside.jsx
var FavoritesAside = __webpack_require__(79255);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 12 modules
var es = __webpack_require__(1515);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-awesome-lightbox/build/index.js
var build = __webpack_require__(57314);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
// EXTERNAL MODULE: ./node_modules/react-awesome-lightbox/build/style.css
var style = __webpack_require__(11835);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js + 3 modules
var combineLatest = __webpack_require__(60236);
// EXTERNAL MODULE: ./src/constants/metaData.js
var metaData = __webpack_require__(51482);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/configsMYO.js
var configsMYO = __webpack_require__(34348);
// EXTERNAL MODULE: ./src/store/cookies.js
var cookies = __webpack_require__(11081);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var store_deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/orderLimitations.js
var orderLimitations = __webpack_require__(39519);
// EXTERNAL MODULE: ./src/store/productsCollection.js
var productsCollection = __webpack_require__(67713);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(90952);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/utils/products.js
var products = __webpack_require__(1003);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/FadeInOutError/FadeInOutError.jsx
var FadeInOutError = __webpack_require__(26604);
// EXTERNAL MODULE: ./src/components/ListButton.jsx
var ListButton = __webpack_require__(22495);
// EXTERNAL MODULE: ./src/components/RoundButton/ButtonCart.jsx + 2 modules
var ButtonCart = __webpack_require__(75547);
// EXTERNAL MODULE: ./src/components/swiper-buttons/NextArrow.jsx
var NextArrow = __webpack_require__(51116);
// EXTERNAL MODULE: ./src/components/swiper-buttons/PrevArrow.jsx
var PrevArrow = __webpack_require__(55416);
// EXTERNAL MODULE: ./src/components/ProductDetails/ProductDetails.module.scss
var ProductDetails_module = __webpack_require__(39523);
var ProductDetails_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetails_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ProductDetails/DetailsExtraInfo.jsx




function DetailsExtraInfo(_ref) {
  var productDetails = _ref.productDetails;

  if (productDetails.ingredients || productDetails.instructions || productDetails.supplierInfo || productDetails.madeIn || productDetails.allergens) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductDetails_module_default()).productDesciption,
      children: [productDetails.ingredients && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTitle,
          children: "\u03A3\u03C5\u03C3\u03C4\u03B1\u03C4\u03B9\u03BA\u03AC"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTextMargin,
          children: productDetails.ingredients
        })]
      }), productDetails.allergens && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTitle,
          children: "\u0391\u03BB\u03BB\u03B5\u03C1\u03B3\u03B9\u03BF\u03B3\u03CC\u03BD\u03B1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTextMargin,
          children: productDetails.allergens
        })]
      }), productDetails.instructions && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTitle,
          children: "\u039F\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2/\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTextMargin,
          children: productDetails.instructions
        })]
      }), productDetails.supplierInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTitle,
          children: "\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03A0\u03C1\u03BF\u03BC\u03B7\u03B8\u03B5\u03CD\u03C4\u03B7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTextMargin,
          children: productDetails.supplierInfo
        })]
      }), productDetails.madeIn && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTitle,
          children: "\u03A7\u03CE\u03C1\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductDetails_module_default()).desciptionTextMargin,
          children: productDetails.madeIn
        })]
      })]
    });
  }

  return null;
}
// EXTERNAL MODULE: ./src/components/ProductDetails/NutritionDetails.module.scss
var NutritionDetails_module = __webpack_require__(64402);
var NutritionDetails_module_default = /*#__PURE__*/__webpack_require__.n(NutritionDetails_module);
;// CONCATENATED MODULE: ./src/components/ProductDetails/NutritionDetails.jsx




function NutritionDetails(_ref) {
  var productDetails = _ref.productDetails;
  if (isEmpty_default()(productDetails === null || productDetails === void 0 ? void 0 : productDetails.nutritionItems)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (NutritionDetails_module_default()).productDesciption,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
            className: (NutritionDetails_module_default()).desciptionTitle,
            children: "\u0394\u03B9\u03B1\u03C4\u03C1\u03BF\u03C6\u03B9\u03BA\u03AC \u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
            className: (NutritionDetails_module_default()).desciptionTitle,
            children: productDetails.nutritionUom ? "(\u03B1\u03BD\u03AC ".concat(productDetails.nutritionUom, ")") : ''
          }), productDetails.nutritionPack && /*#__PURE__*/(0,jsx_runtime.jsxs)("th", {
            className: (NutritionDetails_module_default()).desciptionTitle,
            children: ["(\u03B1\u03BD\u03AC ", productDetails.nutritionPack, ")"]
          }), (productDetails.nutritionPackReferenceIntakeQuota || productDetails.nutritionUomReferenceIntakeQuota) && /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
            className: (NutritionDetails_module_default()).desciptionTitle,
            children: "\u0395.\u0397.\u03A0"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
        children: productDetails.nutritionItems.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              className: (NutritionDetails_module_default()).nutrionItemText,
              children: item.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              className: (NutritionDetails_module_default()).nutrionItemText,
              children: item.perUom
            }), productDetails.nutritionPack && /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              className: (NutritionDetails_module_default()).nutrionItemText,
              children: item.perPack
            }), (productDetails.nutritionPackReferenceIntakeQuota || productDetails.nutritionUomReferenceIntakeQuota) && /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              className: (NutritionDetails_module_default()).nutrionItemText,
              children: item.perUomReferenceIntakeQuota || item.perPackReferenceIntakeQuota || '-'
            })]
          }, item._id);
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/ProductDetails/ProductChoices.module.scss
var ProductChoices_module = __webpack_require__(30680);
var ProductChoices_module_default = /*#__PURE__*/__webpack_require__.n(ProductChoices_module);
;// CONCATENATED MODULE: ./src/components/ProductDetails/ProductChoices.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function ProductChoices(_ref) {
  var product = _ref.product,
      setProduct = _ref.setProduct,
      config = _ref.config,
      isProductMYO = _ref.isProductMYO;

  var _useState = (0,react.useState)(),
      optionSelected = _useState[0],
      setOptionSelected = _useState[1];

  function updateCart() {
    var _option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : optionSelected;

    var optionObject = [{
      _id: _option === null || _option === void 0 ? void 0 : _option._id,
      label: _option === null || _option === void 0 ? void 0 : _option.label
    }];

    var productWithOptions = _objectSpread(_objectSpread({}, product), {}, {
      options: optionObject
    });

    setProduct(productWithOptions);
    var productsInCart = cart/* productsForOrder.getValue */.cW.getValue();
    if (isEmpty_default()(productsInCart)) return;
    var productsInCartOption = productsInCart.map(function (_product) {
      if (_product._id !== product._id) return _product;
      return productWithOptions;
    });
    cart/* productsForOrder.update */.cW.update(productsInCartOption);
  }

  function onClickOption(_option) {
    setOptionSelected(_option);
    updateCart(_option);
  }

  (0,react.useEffect)(function () {
    if (isProductMYO) {
      var defaultOption = product.options ? product.options[0] : config.options[0];
      setOptionSelected(defaultOption);
    }
  }, [isProductMYO, product]);
  if (!isProductMYO) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (ProductChoices_module_default()).optionsTitle,
      children: config.label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductChoices_module_default()).optionsLargeContainer,
      children: config.options.map(function (option) {
        var _cn;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (ProductChoices_module_default()).btnOptions, (optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.label) !== option.label), (0,defineProperty/* default */.Z)(_cn, (ProductChoices_module_default()).btnSelected, (optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.label) === option.label), _cn)),
          onClick: function onClick() {
            return onClickOption(option);
          },
          children: [(optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.label) === option.label ? /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdRadioButtonChecked */.br6, {
            className: (ProductChoices_module_default()).radioSelected
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdRadioButtonUnchecked */.bSN, {
            className: (ProductChoices_module_default()).radio
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: option.label
          })]
        }, option._id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductChoices_module_default()).optionsSmallContainer,
      children: config.options.map(function (option) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductChoices_module_default()).optionsSmallSceen,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (ProductChoices_module_default()).radioOptions,
            onClick: function onClick() {
              return onClickOption(option);
            },
            children: (optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.label) === option.label ? /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdRadioButtonChecked */.br6, {
              className: (ProductChoices_module_default()).radioSmallSelected
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdRadioButtonUnchecked */.bSN, {
              className: (ProductChoices_module_default()).radioSmall
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: option.label
          })]
        }, option._id);
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/ProductDetails/ProductComment.jsx


function ProductComment_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductComment_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductComment_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductComment_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function ProductComment(_ref) {
  var product = _ref.product,
      setProduct = _ref.setProduct;

  var _useState = (0,react.useState)(''),
      comments = _useState[0],
      setComments = _useState[1];

  var _useState2 = (0,react.useState)(),
      productsInCart = _useState2[0],
      setProductsInCart = _useState2[1];

  function updateCart() {
    var productWithComment = ProductComment_objectSpread(ProductComment_objectSpread({}, product), {}, {
      userComments: comments
    });

    setProduct(productWithComment);
    if (isEmpty_default()(productsInCart)) return;
    var productsInCartOption = productsInCart.map(function (_product) {
      if (_product._id !== product._id) return _product;
      return productWithComment;
    });
    cart/* productsForOrder.update */.cW.update(productsInCartOption);
  }

  (0,react.useEffect)(function () {
    var productsForOrder$ = cart/* productsForOrder.subscribe */.cW.subscribe(setProductsInCart);
    return function () {
      return productsForOrder$.unsubscribe();
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!product) return;
    setComments(product.userComments || '');
  }, [product]);

  function onBlurComment() {
    updateCart();
  }

  function onChangeComment(e) {
    setComments(e.target.value);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (ProductChoices_module_default()).optionsTitle,
      children: "\u03A3\u03C7\u03CC\u03BB\u03B9\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
      className: (ProductChoices_module_default()).textArea,
      name: "userComments",
      id: "userComments",
      placeholder: "\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03AD\u03BE\u03BF\u03C5\u03BC\u03B5 \u03BA\u03AC\u03C4\u03B9;",
      onChange: onChangeComment,
      value: comments,
      onBlur: onBlurComment
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/ProductDetails/ProductDetails.jsx



function ProductDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductDetails_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

































var SLIDER_SETTINGS = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow/* default */.Z, {
    smallArrow: true
  }),
  nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow/* default */.Z, {
    smallArrow: true
  }),
  className: (ProductDetails_module_default()).slider
};
var SMALL_SLIDER_SETTINGS = {
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow/* default */.Z, {
    smallArrow: true
  }),
  nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow/* default */.Z, {
    smallArrow: true
  }),
  className: (ProductDetails_module_default()).smallSlider
};
function ProductDetails(_ref) {
  var productDetails = _ref.productDetails,
      _product = _ref._product,
      isProductAvailable = _ref.isProductAvailable,
      badgeText = _ref.badgeText,
      imgSrc = _ref.imgSrc,
      title = _ref.title,
      description = _ref.description,
      productLowestPrice = _ref.productLowestPrice;
  var sliderRef = (0,react.useRef)();
  var previewSliderRef = (0,react.useRef)();

  var _useState = (0,react.useState)([]),
      arrayImg = _useState[0],
      setArrayImg = _useState[1];

  var _useState2 = (0,react.useState)(''),
      currentImg = _useState2[0],
      setCurrentImg = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      productQuantity = _useState3[0],
      setProductQuantity = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      productLimit = _useState4[0],
      setProductLimit = _useState4[1];

  var _useState5 = (0,react.useState)(),
      product = _useState5[0],
      setProduct = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      config = _useState6[0],
      setConfig = _useState6[1];

  var _useState7 = (0,react.useState)(''),
      isProductMYO = _useState7[0],
      setIsProductMYO = _useState7[1];

  var _useState8 = (0,react.useState)(''),
      configDefaultOption = _useState8[0],
      setConfigDefaultOption = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isCartVisible = _useState9[0],
      setIsCartVisible = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      hasReachedMaxQuantity = _useState10[0],
      setHasReachedMaxQuantity = _useState10[1];

  function returnUomTag(uom) {
    if (uom === 'ΚΙΛ') {
      return 'κιλό';
    }

    if (uom === 'ΛΙΤ') {
      return 'λίτρο';
    }

    if (uom === 'ΜΕΖ') {
      return 'μεζούρα';
    }

    if (uom === 'TEM') {
      return 'τεμάχιο';
    }

    if (uom === 'ΜΕΤΡΟ') {
      return 'μέτρο';
    }

    if (uom === 'ΤΜ') {
      return 'τ.μ.';
    }
  }

  function onClickAlternative(index, img) {
    sliderRef.current.slickGoTo(index);
    previewSliderRef.current.slickGoTo(index);
    setCurrentImg(img);
  }

  function getProductFromCart() {
    var productsInCart = cart/* productsForOrder.getValue */.cW.getValue();
    var productInCart = productsInCart.find(function (p) {
      return p.sku === _product.sku;
    });
    return productInCart || [];
  }

  function getCollectionType(collectionTypes, collection) {
    if (isEmpty_default()(collection)) {
      return;
    }

    if ((collectionTypes === null || collectionTypes === void 0 ? void 0 : collectionTypes.length) > 1) {
      if (!collection[collectionTypes[0]] || !collection[collectionTypes[1]]) {
        return;
      }

      var easyProduct = collection[collectionTypes[0]].find(function (p) {
        return p.sku === _product.sku;
      });
      var localProduct = collection[collectionTypes[1]].find(function (p) {
        return p.sku === _product.sku;
      });

      if (easyProduct) {
        return collectionTypes[0];
      }

      if (localProduct) {
        return collectionTypes[1];
      }

      console.debug('no collection for this product');
    }

    return collectionTypes[0];
  }

  (0,react.useEffect)(function () {
    var isCartVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(setIsCartVisible);
    var modeAndCollection$ = (0,combineLatest/* combineLatest */.aj)([store_deliveryMode/* default.lazyInit */.Z.lazyInit(), productsCollection/* default.subject */.Z.subject]).subscribe(function (res) {
      var collectionTypes = store_deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(res[0]);
      var collectionType = getCollectionType(collectionTypes, res[1]);
      var productsOfCollection = res[1][collectionType];

      if (!isEmpty_default()(productsOfCollection)) {
        var updatedProduct = productsOfCollection.find(function (p) {
          return p.sku === _product.sku;
        });

        if (updatedProduct) {
          var productInCart = getProductFromCart();

          var finalProduct = ProductDetails_objectSpread(ProductDetails_objectSpread({}, productInCart), updatedProduct);

          setProduct(finalProduct);
        }
      }
    });
    var privacy = cookies/* default.getValue */.Z.getValue();

    if (privacy && privacy.performance) {
      (0,analytics/* addToAnalytics */.z2)('ecomProductShow', (0,analytics/* getProductInfo */.Cn)(productDetails));
    }

    return function () {
      isCartVisible$.unsubscribe();
      modeAndCollection$.unsubscribe();
    };
  }, [_product]);
  (0,react.useEffect)(function () {
    if (!product) return utils/* earlyInUseEffect */.Z;
    var productQuantityAndLimits$ = (0,combineLatest/* combineLatest */.aj)([cart/* productsQuantities.lazyInit */.UU.lazyInit(), orderLimitations/* default.subject */.Z.subject]).subscribe(function (res) {
      var _productQuantity = res[0][product._id];
      setProductQuantity(_productQuantity);
      var limit = (0,products/* getProductOrderLimit */.sA)(res[1], product);
      setProductLimit(limit);
      (0,products/* productsLimitReached */.B2)(product, _productQuantity, setHasReachedMaxQuantity, limit);
    });
    return function () {
      productQuantityAndLimits$.unsubscribe();
    };
  }, [product]);
  (0,react.useEffect)(function () {
    if (!product) return utils/* earlyInUseEffect */.Z;
    var _product$images = product.images,
        primary = _product$images.primary,
        _product$images$alter = _product$images.alternatives,
        alternatives = _product$images$alter === void 0 ? [] : _product$images$alter;
    var imageObjects = [primary].concat((0,toConsumableArray/* default */.Z)(alternatives));
    var imageUrls = imageObjects.map(function (img) {
      return (0,products/* productImageURL */.k1)(img, 'productDetailsTile');
    });
    setArrayImg(imageUrls);
    var configsMyo$ = configsMYO/* default.subscribe */.Z.subscribe(function (configs) {
      var configApplied = configs.find(function (c) {
        return c.productSkus.includes(product.sku);
      });

      if (!configApplied) {
        setIsProductMYO(false);
        return;
      }

      var defaultOption = configApplied.options.find(function (option) {
        return option._id === configApplied.defaultOptionsId;
      });
      var isThisProductMYO = configApplied === null || configApplied === void 0 ? void 0 : configApplied.productSkus.includes(product.sku);
      setIsProductMYO(isThisProductMYO);
      setConfigDefaultOption(defaultOption);
      setConfig(configApplied);
    });
    return function () {
      configsMyo$.unsubscribe();
    };
  }, [product]);
  if (!_product) return null;

  var meta = ProductDetails_objectSpread(ProductDetails_objectSpread({}, metaData/* default */.Z["kritikos"].productDetails), {}, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(_product.slug, "/"),
    description: "".concat(title, " - ").concat(description, ". ").concat(productDetails.description || ''),
    title: _product.name,
    image: imgSrc,
    keywords: _product.tags.join(',')
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      meta: meta
    }), currentImg && /*#__PURE__*/(0,jsx_runtime.jsx)((build_default()), {
      image: currentImg,
      title: title,
      allowRotate: false,
      allowReset: false,
      onClose: function onClose() {
        return setCurrentImg('');
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: classnames_default()((ProductDetails_module_default()).productDetailsContainer, (0,defineProperty/* default */.Z)({}, (ProductDetails_module_default()).spaceOpenCart, isCartVisible)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductDetails_module_default()).productDetailsSliders,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductDetails_module_default()).sliders,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ProductDetails_module_default()).productImgContainerWrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductDetails_module_default()).productImgContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, ProductDetails_objectSpread(ProductDetails_objectSpread({}, SLIDER_SETTINGS), {}, {
                ref: sliderRef,
                children: arrayImg.map(function (img) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (ProductDetails_module_default()).container,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (ProductDetails_module_default()).openOverLayImg,
                        onClick: function onClick() {
                          return setCurrentImg(img);
                        },
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          className: (ProductDetails_module_default()).imgSlider,
                          width: "286",
                          height: "286",
                          src: img,
                          alt: title
                        })
                      })
                    })
                  }, img);
                })
              }))
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, ProductDetails_objectSpread(ProductDetails_objectSpread({}, SMALL_SLIDER_SETTINGS), {}, {
            ref: previewSliderRef,
            children: arrayImg.map(function (img, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (ProductDetails_module_default()).imgButtons,
                type: "button",
                onClick: function onClick() {
                  return onClickAlternative(i, img);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (ProductDetails_module_default()).smallSliderImg,
                  width: "48",
                  height: "48",
                  src: img,
                  alt: title
                })
              }, img);
            })
          }))]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductDetails_module_default()).productDetailsInfo,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (ProductDetails_module_default()).upperSection,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ProductDetails_module_default()).headerContainer,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: badgeText && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (ProductDetails_module_default()).offerPercentage,
                    children: badgeText
                  })
                }), product && /*#__PURE__*/(0,jsx_runtime.jsx)(ListButton/* default */.Z, {
                  product: product,
                  isProductDetails: true
                }), product && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (ProductDetails_module_default()).buttonCartSmallScreen,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonCart/* default */.Z, {
                    product: product,
                    productLimit: productLimit,
                    quantity: productQuantity,
                    isProductMYO: isProductMYO,
                    configDefaultOption: configDefaultOption,
                    removed: !isProductAvailable,
                    squared: true,
                    isEditable: true
                  }), hasReachedMaxQuantity && /*#__PURE__*/(0,jsx_runtime.jsx)(FadeInOutError/* default */.Z, {})]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: (ProductDetails_module_default()).productName,
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (ProductDetails_module_default()).productCode,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (ProductDetails_module_default()).boldText,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* IoCheckmarkCircle */.cfq, {
                    className: (ProductDetails_module_default()).checkMarkImg,
                    alt: "checkmark"
                  }), description]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "- \u039A\u03C9\u03B4. \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 ".concat(_product.sku)
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ProductDetails_module_default()).middleContainer,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (ProductDetails_module_default()).textFlex,
                  children: [product && (product.uom === 'ΚΙΛ' ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: (ProductDetails_module_default()).priceText,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (ProductDetails_module_default()).price,
                      children: "\u20AC ".concat((product.finalPrice * product.stepToUom / 100).toFixed(2), " ")
                    }), product.offerType !== 'none' && product.beginPrice > product.finalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).lineThroughText, (ProductDetails_module_default()).greyPrice),
                      children: "".concat((product.beginPrice * product.stepToUom / 100).toFixed(2), " ")
                    }), "\u03B1\u03BD\u03AC ".concat(1000 * product.stepToUom, "\u03B3\u03C1.")]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: (ProductDetails_module_default()).priceText,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (ProductDetails_module_default()).price,
                      children: "\u20AC ".concat((product.finalPrice / 100).toFixed(2), " ")
                    }), product.offerType !== 'none' && product.beginPrice > product.finalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).lineThroughText, (ProductDetails_module_default()).greyPrice),
                      children: "".concat((product.beginPrice * product.stepToUom / 100).toFixed(2), " ")
                    }), "\u03B1\u03BD\u03AC ".concat(returnUomTag(product.uom))]
                  })), product && (product.uom === 'ΚΙΛ' ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: classnames_default()((ProductDetails_module_default()).greyPriceText),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).greyPrice),
                      children: "\u20AC ".concat((product.unitOfMeasurementFinalPrice / 100).toFixed(2), " ")
                    }), product.offerType !== 'none' && product.beginPrice > product.finalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).lineThroughText, (ProductDetails_module_default()).grey),
                      children: "".concat((product.unitOfMeasurementBeginPrice / 100).toFixed(2), " ")
                    }), "\u03B1\u03BD\u03AC ".concat(product.quantity)]
                  }) : product !== null && product !== void 0 && product.unitOfMeasurement && returnUomTag(product.unitOfMeasurement) ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: classnames_default()((ProductDetails_module_default()).greyPriceText),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (ProductDetails_module_default()).greyPrice,
                      children: "\u20AC ".concat((product.unitOfMeasurementFinalPrice / 100).toFixed(2), " ")
                    }), product.offerType !== 'none' && product.beginPrice > product.finalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).grey, (ProductDetails_module_default()).lineThroughText),
                      children: "".concat((product.unitOfMeasurementBeginPrice / 100).toFixed(2), " ")
                    }), "\u03B1\u03BD\u03AC ".concat(returnUomTag(product.unitOfMeasurement))]
                  }) : null), product && product.offerType !== 'none' && productLowestPrice && productLowestPrice.price && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (ProductDetails_module_default()).lowestPriceContainer,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (ProductDetails_module_default()).stocksIcon
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()((ProductDetails_module_default()).lowestPriceText),
                      children: "\u03A7\u03B1\u03BC\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03C4\u03B9\u03BC\u03AE  30 \u03B7\u03BC\u03B5\u03C1\u03CE\u03BD: ".concat(product.uom === 'ΚΙΛ' ? (productLowestPrice.price / 100).toFixed(2) : (productLowestPrice.price / 100).toFixed(2), " ").concat(product.uom === 'ΚΙΛ' ? '€ /' : '€', "\n                         ").concat(product.uom === 'ΚΙΛ' ? returnUomTag(product.unitOfMeasurement) : '')
                    })]
                  })]
                }), product && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (ProductDetails_module_default()).buttonCart,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonCart/* default */.Z, {
                    product: product,
                    productLimit: productLimit,
                    quantity: productQuantity,
                    isProductMYO: isProductMYO,
                    configDefaultOption: configDefaultOption,
                    squared: true,
                    removed: !isProductAvailable,
                    isEditable: true
                  }), hasReachedMaxQuantity && /*#__PURE__*/(0,jsx_runtime.jsx)(FadeInOutError/* default */.Z, {})]
                })]
              })]
            }), config && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductChoices, {
              product: product,
              setProduct: setProduct,
              config: config,
              isProductMYO: isProductMYO
            }), product && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductComment, {
              product: product,
              setProduct: setProduct
            })]
          }), productDetails.description && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ProductDetails_module_default()).productDesciption,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (ProductDetails_module_default()).desciptionTitle,
              children: "\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (ProductDetails_module_default()).desciptionText,
              children: productDetails.description
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DetailsExtraInfo, {
            productDetails: productDetails
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NutritionDetails, {
            productDetails: productDetails
          })]
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/store/productsSort.js
var productsSort = __webpack_require__(43660);
// EXTERNAL MODULE: ./src/utils/bannerOptions.js
var bannerOptions = __webpack_require__(76962);
// EXTERNAL MODULE: ./src/utils/getBreadcrumb.js
var getBreadcrumb = __webpack_require__(65269);
// EXTERNAL MODULE: ./src/utils/storeRelationShips.js + 2 modules
var storeRelationShips = __webpack_require__(74150);
// EXTERNAL MODULE: ./src/pages/products/products.module.scss
var products_module = __webpack_require__(22097);
var products_module_default = /*#__PURE__*/__webpack_require__.n(products_module);
;// CONCATENATED MODULE: ./src/pages/products/[...slug].jsx







/* Components */













/* API */

/* Controllers */







/* Styles */







var __N_SSG = true;
function _slug_Products(_ref) {
  var categories = _ref.categories,
      navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      productSelected = _ref.productSelected,
      productDetails = _ref.productDetails,
      badgeText = _ref.badgeText,
      imgSrc = _ref.imgSrc,
      productDetailsTitle = _ref.productDetailsTitle,
      description = _ref.description,
      category = _ref.category;

  var _useState = (0,react.useState)(''),
      deliveryMode = _useState[0],
      setDeliveryMode = _useState[1];

  var _useState2 = (0,react.useState)(bannerOptions/* default.catalog */.Z.catalog),
      showBySelection = _useState2[0],
      setShowBySelection = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isCartVisible = _useState3[0],
      setIsCartVisible = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      isProductAvailable = _useState4[0],
      setIsProductAvailable = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      productLowestPrice = _useState5[0],
      setProductLowestPrice = _useState5[1];

  var router = (0,next_router.useRouter)();
  var slug = router.query.slug;
  var breadcrumbData = slug.map(function (value, index) {
    return (0,getBreadcrumb/* getBreadcrumbStepProduct */.aY)(slug, index);
  });
  var validatedBreadcrumbData = (0,getBreadcrumb/* getBreadcrumbValidation */.CH)(breadcrumbData);
  var breadcrumb = (0,getBreadcrumb/* createBreadcrumbJson */.El)(validatedBreadcrumbData);
  var categoryName = (0,products/* getCategoryName */.Oo)(slug, categories);
  var subCategoryName = (0,products/* getSubCategoryName */.pB)(slug, categories);
  var title = (0,products/* getPageTitle */.pz)(slug, categories);
  (0,react.useEffect)(function () {
    var subscriptionDeliveryMode = store_deliveryMode/* default.subscribe */.Z.subscribe(setDeliveryMode);
    var isCartVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(setIsCartVisible);
    var sortBy$ = productsSort/* default.subscribe */.Z.subscribe(setShowBySelection);
    var serviceShopCollection$ = (0,storeRelationShips/* initServiceShopCollectionRelationship */.lU)(productSelected, setIsProductAvailable);
    getHistory();
    (0,analytics/* viewItem */.R9)((0,analytics/* getProductInfo */.Cn)(productSelected));
    return function () {
      sortBy$.unsubscribe();
      isCartVisible$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
      serviceShopCollection$.unsubscribe();
    };
  }, []);

  function getHistory() {
    return _getHistory.apply(this, arguments);
  }

  function _getHistory() {
    _getHistory = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var today, oneMonthBefore, _yield$getProductPric, prices, lowestPriceHistory;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              today = dayjs_min_default()();
              oneMonthBefore = today.subtract(1, 'month');
              _context.next = 4;
              return (0,Products/* getProductPriceHistory */.fp)(productSelected._id, oneMonthBefore.format('YYYY-MM-DD'), today.format('YYYY-MM-DD'));

            case 4:
              _yield$getProductPric = _context.sent;
              prices = _yield$getProductPric.prices;
              lowestPriceHistory = findLowestPriceEntry(prices);
              setProductLowestPrice(lowestPriceHistory);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getHistory.apply(this, arguments);
  }

  function findLowestPriceEntry(entries) {
    if (!entries || entries.length === 0) {
      return null; // Return null if the array is empty or invalid
    }

    return entries.reduce(function (lowest, entry) {
      return entry.price < lowest.price ? entry : lowest;
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: title
    }, "title"), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).headerContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation,
        isEnabled: true
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryBanner/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSelect/* default */.Z, {
      slug: slug
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      className: classnames_default()((products_module_default()).main, (0,defineProperty/* default */.Z)({}, (products_module_default()).spaceOpenCart, isCartVisible)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()([(products_module_default()).mainLeft, (products_module_default()).listBanner]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesBanner/* default */.Z, {
            onChangeOrderBy: function onChangeOrderBy(e) {
              return productsSort/* default.update */.Z.update(e.target.value);
            },
            showBySelection: showBySelection,
            numOfProducts: 0,
            categoryName: categoryName,
            subCategoryName: subCategoryName,
            slug: slug,
            deliveryMode: deliveryMode,
            hideOrderBy: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: (products_module_default()).mainContent,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (products_module_default()).hideOnSmallScreen,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()([(products_module_default()).categoriesAsideProductDetails]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoritesAside/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAside/* default */.Z, {
                category: category,
                slug: slug
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductDetails, {
            productDetails: productDetails,
            _product: productSelected,
            isProductAvailable: isProductAvailable,
            badgeText: badgeText,
            imgSrc: imgSrc,
            title: productDetailsTitle,
            description: description,
            productLowestPrice: productLowestPrice
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 90952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ earlyInUseEffect; }
/* harmony export */ });
/**
 * Use to early return in useEffect.
 * Usage example `return earlyInUseEffect;`
 */
function earlyInUseEffect() {
  return {};
}

/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[...slug]",
      function () {
        return __webpack_require__(33401);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"ListButton_btn__tmXEU","floating":"ListButton_floating__MYjUr","icon":"ListButton_icon__YhRti","iconSuggested":"ListButton_iconSuggested__TqXCk","favoriteContainer":"ListButton_favoriteContainer__4dwhN","favoriteBtn":"ListButton_favoriteBtn__pNNrQ","favoritesText":"ListButton_favoritesText__DI4p5","animation":"ListButton_animation__f3tr5","heartbeat":"ListButton_heartbeat__Q6WrN"};

/***/ }),

/***/ 64402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productDesciption":"NutritionDetails_productDesciption__SxWeF","desciptionTitle":"NutritionDetails_desciptionTitle__k14Yb","nutrionItemText":"NutritionDetails_nutrionItemText__acUR2"};

/***/ }),

/***/ 30680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"optionsTitle":"ProductChoices_optionsTitle__0yOVY","btn":"ProductChoices_btn__SU_Mq","btnSelected":"ProductChoices_btnSelected__rdKNJ","btnOptions":"ProductChoices_btnOptions__o96tf","radioOptions":"ProductChoices_radioOptions__0pqHr","radioSmall":"ProductChoices_radioSmall__EMQxQ","radioSmallSelected":"ProductChoices_radioSmallSelected__yRvJO","radioSelected":"ProductChoices_radioSelected__7LixU","radio":"ProductChoices_radio__bltSI","optionsSmallContainer":"ProductChoices_optionsSmallContainer___fxqn","textArea":"ProductChoices_textArea__NMOBl","optionsLargeContainer":"ProductChoices_optionsLargeContainer__mBUCU","optionsSmallSceen":"ProductChoices_optionsSmallSceen__CNBw8"};

/***/ }),

/***/ 80075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NextArrow_container__QNOMg","leaflet":"NextArrow_leaflet__pv9Bi","categoryContainer":"NextArrow_categoryContainer__32KPf","smallArrow":"NextArrow_smallArrow__eYUrr","carouselContainer":"NextArrow_carouselContainer__PSlWF","icon":"NextArrow_icon__cN9Ar"};

/***/ }),

/***/ 19392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PrevArrow_container__ebi1s","leaflet":"PrevArrow_leaflet__sW3Rf","smallArrow":"PrevArrow_smallArrow__BjbkX","categoryContainer":"PrevArrow_categoryContainer__iWgpN","carouselContainer":"PrevArrow_carouselContainer__4XFzB","icon":"PrevArrow_icon__Wjv_m"};

/***/ }),

/***/ 22097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"products_main__TtvX6","mainLeft":"products_mainLeft__Zq_Pd","listContainer":"products_listContainer___Yoas","listBanner":"products_listBanner__Vqeci","mainContent":"products_mainContent__SRXIi","defaultContainer":"products_defaultContainer__XTPoZ","listBannerSearch":"products_listBannerSearch__xE6mU","listSearch":"products_listSearch__oQH6E","mainList":"products_mainList__SPxdH","sticky":"products_sticky__gf_n1","categoriesAsideProductDetails":"products_categoriesAsideProductDetails__b9XMz","spaceOpenCart":"products_spaceOpenCart__StTkZ","categoriesAsideTop":"products_categoriesAsideTop__9uz0r","productsListContainer":"products_productsListContainer__IY8_d","offerListContainer":"products_offerListContainer__7kkh6","offerListWrapper":"products_offerListWrapper__CzhiT","productScrollingContainer":"products_productScrollingContainer__1CZkB","hideOnSmallScreen":"products_hideOnSmallScreen__gR_BI"};

/***/ }),

/***/ 11835:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports=function(t){var e={};function o(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=t,o.c=e,o.d=function(t,e,n){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)o.d(n,r,function(e){return t[e]}.bind(null,r));return n},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="",o(o.s=1)}([function(t,e){t.exports=__webpack_require__(67294)},function(t,e,o){"use strict";o.r(e),o.d(e,"default",(function(){return b}));var n=o(0),r=o.n(n);function a(t){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){for(var o=0;o<e.length;o++){var n=e[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function c(t,e){return(c=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function u(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var o,n=d(t);if(e){var r=d(this).constructor;o=Reflect.construct(n,arguments,r)}else o=n.apply(this,arguments);return s(this,o)}}function s(t,e){return!e||"object"!==a(e)&&"function"!=typeof e?f(t):e}function f(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function d(t){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function m(t,e,o){return e in t?Object.defineProperty(t,e,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[e]=o,t}function p(t){var e=0,o=0;return t.touches&&t.touches.length?(e=t.touches[0].pageX,o=t.touches[0].pageY):(e=t.pageX,o=t.pageY),{x:e,y:o}}function v(t){return t.condition?r.a.createElement(r.a.Fragment,null,t.children):null}var b=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&c(t,e)}(s,t);var e,o,n,a=u(s);function s(){var t,e,o,n,l;i(this,s);for(var c=arguments.length,u=new Array(c),d=0;d<c;d++)u[d]=arguments[d];return m(f(l=a.call.apply(a,[this].concat(u))),"initX",0),m(f(l),"initY",0),m(f(l),"lastX",0),m(f(l),"lastY",0),m(f(l),"_cont",r.a.createRef()),m(f(l),"state",{x:0,y:0,zoom:1,rotate:0,loading:!0,moving:!1,current:null!==(t=null===(e=l.props)||void 0===e?void 0:e.startIndex)&&void 0!==t?t:0,multi:!(null===(o=l.props)||void 0===o||null===(n=o.images)||void 0===n||!n.length)}),m(f(l),"createTransform",(function(t,e,o,n){return"translate3d(".concat(t,"px,").concat(e,"px,0px) scale(").concat(o,") rotate(").concat(n,"deg)")})),m(f(l),"stopSideEffect",(function(t){return t.stopPropagation()})),m(f(l),"getCurrentImage",(function(t,e){var o,n,r,a,i;return t.multi?null!==(n=null!==(r=null===(a=e.images[t.current])||void 0===a?void 0:a.url)&&void 0!==r?r:null===(i=e.images)||void 0===i?void 0:i[t.current])&&void 0!==n?n:"":null!==(o=e.image)&&void 0!==o?o:""})),m(f(l),"getCurrentTitle",(function(t,e){var o,n,r,a;return t.multi?null!==(n=null===(r=e.images)||void 0===r||null===(a=r[t.current])||void 0===a?void 0:a.title)&&void 0!==n?n:"":null!==(o=e.title)&&void 0!==o?o:""})),m(f(l),"resetZoom",(function(){return l.setState({x:0,y:0,zoom:1})})),m(f(l),"shockZoom",(function(t){var e,o,n=l.props,r=n.zoomStep,a=void 0===r?.3:r,i=n.allowZoom,c=void 0===i||i,u=n.doubleClickZoom,s=void 0===u?4:u;if(!c||!s)return!1;if(l.stopSideEffect(t),l.state.zoom>1)return l.resetZoom();var f=(a<1?Math.ceil(s/a):a)*a,d=p(t),m=null===(e=l._cont.current)||void 0===e||null===(o=e.getBoundingClientRect)||void 0===o?void 0:o.call(e),v=m.x+m.width/2,b=m.y+m.height/2,y=-1*(d.x-v)*f,g=-1*(d.y-b)*f;l.setState({x:y,y:g,zoom:f})})),m(f(l),"navigateImage",(function(t,e){l.stopSideEffect(e);var o=0;switch(t){case"next":o=l.state.current+1;break;case"prev":o=l.state.current-1}o>=l.props.images.length?o=0:o<0&&(o=l.props.images.length-1),l.setState({current:o,x:0,y:0,zoom:1,rotate:0,loading:!0})})),m(f(l),"startMove",(function(t){if(l.state.zoom<=1)return!1;l.setState({moving:!0});var e=p(t);l.initX=e.x-l.lastX,l.initY=e.y-l.lastY})),m(f(l),"duringMove",(function(t){if(!l.state.moving)return!1;var e=p(t);l.lastX=e.x-l.initX,l.lastY=e.y-l.initY,l.setState({x:e.x-l.initX,y:e.y-l.initY})})),m(f(l),"endMove",(function(t){return l.setState({moving:!1})})),m(f(l),"applyZoom",(function(t){var e=l.props.zoomStep,o=void 0===e?.3:e;switch(t){case"in":l.setState({zoom:l.state.zoom+o});break;case"out":var n=l.state.zoom-o;if(n<1)break;1===n?l.setState({x:0,y:0,zoom:1}):l.setState({zoom:n});break;case"reset":l.resetZoom()}})),m(f(l),"applyRotate",(function(t){switch(t){case"cw":l.setState({rotate:l.state.rotate+90});break;case"acw":l.setState({rotate:l.state.rotate-90})}})),m(f(l),"reset",(function(t){l.stopSideEffect(t),l.setState({x:0,y:0,zoom:1,rotate:0})})),m(f(l),"exit",(function(t){if("function"==typeof l.props.onClose)return l.props.onClose(t);console.error("No Exit function passed on prop: onClose. Clicking the close button will do nothing")})),m(f(l),"shouldShowReset",(function(){return l.state.x||l.state.y||1!==l.state.zoom||0!==l.state.rotate})),m(f(l),"canvasClick",(function(t){var e=l.props.clickOutsideToExit;if((void 0===e||e)&&l.state.zoom<=1)return l.exit(t)})),m(f(l),"keyboardNavigation",(function(t){var e=l.props,o=e.allowZoom,n=void 0===o||o,r=e.allowReset,a=void 0===r||r,i=l.state,c=i.multi,u=i.x,s=i.y,f=i.zoom;switch(t.key){case"ArrowLeft":c&&1===f?l.navigateImage("prev",t):f>1&&l.setState({x:u-20});break;case"ArrowRight":c&&1===f?l.navigateImage("next",t):f>1&&l.setState({x:u+20});break;case"ArrowUp":f>1&&l.setState({y:s+20});break;case"ArrowDown":f>1&&l.setState({y:s-20});break;case"+":n&&l.applyZoom("in");break;case"-":n&&l.applyZoom("out");break;case"Escape":a&&l.shouldShowReset()?l.reset(t):l.exit(t)}})),l}return e=s,(o=[{key:"componentDidMount",value:function(){document.body.classList.add("lb-open-lightbox");var t=this.props.keyboardInteraction;(void 0===t||t)&&document.addEventListener("keyup",this.keyboardNavigation)}},{key:"componentWillUnmount",value:function(){document.body.classList.remove("lb-open-lightbox");var t=this.props.keyboardInteraction;(void 0===t||t)&&document.removeEventListener("keyup",this.keyboardNavigation)}},{key:"render",value:function(){var t=this,e=this.getCurrentImage(this.state,this.props),o=this.getCurrentTitle(this.state,this.props);if(!e)return console.warn("Not showing lightbox because no image(s) was supplied"),null;var n=this.props,a=n.allowZoom,i=void 0===a||a,l=n.allowRotate,c=void 0===l||l,u=n.buttonAlign,s=void 0===u?"flex-end":u,f=n.showTitle,d=void 0===f||f,m=n.allowReset,p=void 0===m||m,b=this.state,y=b.x,g=b.y,h=b.zoom,x=b.rotate,w=b.multi,k=b.loading,S=b.moving,E=p&&this.shouldShowReset();return r.a.createElement("div",{className:"lb-container"},r.a.createElement("div",{className:"lb-header",style:{justifyContent:s}},r.a.createElement(v,{condition:d&&o},r.a.createElement("div",{className:"lb-title",style:{display:"center"===s?"none":"flex",order:"flex-start"===s?"2":"unset"}},r.a.createElement("span",{title:o,style:{textAlign:"flex-start"===s?"right":"left"}},o))),r.a.createElement(v,{condition:"center"===s||E},r.a.createElement("div",{title:"Reset",style:{order:"flex-start"===s?"1":"unset"},className:"lb-button lb-icon-reset lb-hide-mobile reload ".concat(E?"":"lb-disabled"),onClick:this.reset})),r.a.createElement(v,{condition:w},r.a.createElement("div",{title:"Previous",className:"lb-button lb-icon-arrow prev lb-hide-mobile",onClick:function(e){return t.navigateImage("prev",e)}}),r.a.createElement("div",{title:"Next",className:"lb-button lb-icon-arrow next lb-hide-mobile",onClick:function(e){return t.navigateImage("next",e)}})),r.a.createElement(v,{condition:i},r.a.createElement("div",{title:"Zoom In",className:"lb-button lb-icon-zoomin zoomin",onClick:function(){return t.applyZoom("in")}}),r.a.createElement("div",{title:"Zoom Out",className:"lb-button lb-icon-zoomout zoomout ".concat(h<=1?"lb-disabled":""),onClick:function(){return t.applyZoom("out")}})),r.a.createElement(v,{condition:c},r.a.createElement("div",{title:"Rotate left",className:"lb-button lb-icon-rotate rotatel",onClick:function(){return t.applyRotate("acw")}}),r.a.createElement("div",{title:"Rotate right",className:"lb-button lb-icon-rotate rotater",onClick:function(){return t.applyRotate("cw")}})),r.a.createElement("div",{title:"Close",className:"lb-button lb-icon-close close",style:{order:"flex-start"===s?"-1":"unset"},onClick:function(e){return t.exit(e)}})),r.a.createElement("div",{className:"lb-canvas".concat(k?" lb-loading":""),ref:this._cont,onClick:function(e){return t.canvasClick(e)}},r.a.createElement("img",{draggable:"false",style:{transform:this.createTransform(y,g,h,x),cursor:h>1?"grab":"unset",transition:S?"none":"all 0.1s"},onMouseDown:function(e){return t.startMove(e)},onTouchStart:function(e){return t.startMove(e)},onMouseMove:function(e){return t.duringMove(e)},onTouchMove:function(e){return t.duringMove(e)},onMouseUp:function(e){return t.endMove(e)},onMouseLeave:function(e){return t.endMove(e)},onTouchEnd:function(e){return t.endMove(e)},onClick:function(e){return t.stopSideEffect(e)},onDoubleClick:function(e){return t.shockZoom(e)},onLoad:function(e){return t.setState({loading:!1})},className:"lb-img".concat(k?" lb-loading":""),title:o,src:e,alt:o}),r.a.createElement("div",{className:"mobile-controls lb-show-mobile"},w?r.a.createElement("div",{title:"Previous",className:"lb-button lb-icon-arrow prev",onClick:function(e){return t.navigateImage("prev",e)}}):null,E?r.a.createElement("div",{title:"Reset",className:"lb-button lb-icon-reset reload",onClick:this.reset}):null,w?r.a.createElement("div",{title:"Next",className:"lb-button lb-icon-arrow next",onClick:function(e){return t.navigateImage("next",e)}}):null)))}}])&&l(e.prototype,o),n&&l(e,n),s}(r.a.Component)}]);

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 91:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,1515,7180,9950,9878,3231,7895,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(4186); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);